<template>
  <BaseDropDownMenu
    :title="$t('global.action')"
    size="small"
    :options="options"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'InvoicingActionDropDown',
  emits: ['buttonSend', 'changeItemOrder'],
  computed: {
    ...mapGetters({
      invoice: 'invoicing/getInvoice',
      metadata: 'invoicing/getInvoiceMetadata'
    }),
    options() {
      const canManage = this.$can('manage_invoicing')
      return [
        [
          {
            label: this.$t('button.clone'),
            icon: 'copy',
            gate: canManage,
            action: this.handleCloneInvoice
          },
          {
            label: this.$t('button.edit'),
            icon: 'edit',
            // Sent on Peppol and not rejected: the back refuses any change.
            gate: canManage && !this.invoice?.peppol_locked,
            action: () =>
              this.$router.push({
                name: 'invoice_form_edit_route',
                params: { invoicing_id: this.$route.params.invoicing_id }
              })
          },
          {
            label: this.$t('button.change_item_order'),
            icon: 'sort-alt',
            gate: canManage && !this.invoice?.peppol_locked,
            action: () => this.$emit('changeItemOrder')
          },
          {
            label: this.$t('button.send'),
            icon: 'paper-plane',
            gate: canManage,
            action: () => this.$emit('buttonSend')
          }
        ],
        (this.metadata?.convertissable_types ?? []).map((type) => ({
          label: this.$t('button.convert_to', {
            var: this.$t('enums.invoicing.type.' + type)
          }),
          icon: 'arrow-right',
          gate: canManage,
          action: () => this.handleConvertInvoice(type)
        }))
      ]
    }
  },
  methods: {
    ...mapActions({
      cloneInvoice: 'invoicing/cloneInvoice',
      convertInvoice: 'invoicing/convertInvoice'
    }),
    handleCloneInvoice() {
      this.cloneInvoice({ invoice_id: this.invoice.id }).then(() => {
        this.$h.toastSuccess(
          this.$t('toasts.cloned_f', { var: this.$t('global.invoice') })
        )
      })
    },
    handleConvertInvoice(type) {
      this.convertInvoice({
        invoice_id: this.invoice.id,
        doc_type: type
      }).then(() => {
        this.$h.toastSuccess(
          type === 'INV' || type === 'CN'
            ? this.$t('toasts.converted_f', {
                var: this.$t(`enums.invoicing.type.${type}`)
              })
            : this.$t('toasts.converted_m', {
                var: this.$t(`enums.invoicing.type.${type}`)
              })
        )
      })
    }
  }
}
</script>
